import type { FunctionalComponent, SVGAttributes } from 'vue'

export const CompareIcon: FunctionalComponent<SVGAttributes> = (props) => {
  return (
    <svg xmlns="http://www.w3.org/2000/svg" width="22" height="8" viewBox="0 0 22 8" fill="none" {...props}>
      <path
        d="M1.88658 5.74311C1.38379 5.74311 0.976562 6.12533 0.976562 6.59329C0.976562 7.06303 1.38379 7.44436 1.88658 7.44436H20.1114C20.9357 7.44436 21.3349 6.5013 20.7339 5.97262L14.7449 0.785247C14.6248 0.682239 14.481 0.610621 14.3264 0.576802C14.1718 0.542983 14.0112 0.548018 13.859 0.591456C13.7097 0.630933 13.5734 0.709105 13.464 0.81808C13.3545 0.927056 13.2758 1.06298 13.2357 1.21212C13.1615 1.50861 13.2624 1.81939 13.5 2.02658L17.8136 5.74311H1.88658Z"
        fill="var(--colors-bg-icon-primary)"
      />
    </svg>
  )
}
